module.exports = __webpack_public_path__ + "static/media/8A024742-1DE5-4AD8-A978-39EBD5A6F00E.2b2407c9.JPG";